import { render, staticRenderFns } from "./SortColumn.vue?vue&type=template&id=340d0ad8&scoped=true&"
import script from "./SortColumn.vue?vue&type=script&lang=js&"
export * from "./SortColumn.vue?vue&type=script&lang=js&"
import style0 from "./SortColumn.vue?vue&type=style&index=0&id=340d0ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d0ad8",
  null
  
)

export default component.exports